<div class="row" *ngIf="!file">
  <div class="col-md-12">
    <div class="drop-zone hover:font-medium" ng2FileDrop [uploader]="uploader" (click)="file.click()">
      Drop files here
    </div>
    <input type="file" [accept]="accepts" #file style="visibility: hidden" (change)="onFileChange($event)"/>
  </div>
</div>

<div >
  <span *ngIf="file" class="mt-2"> {{ 'attachment' | translate }} </span>
  <div class="p-2 my-2 font-medium rounded-md bg-white border flex justify-between items-center"
       *ngIf="file" >
    <span class="font-medium text-muted">{{ file.name }}</span>
    <mat-icon color="warn" matTooltipClass="danger-tooltip"
              matRipple matTooltip="{{ 'remove' | translate }}"
              (click)="file = null; selectedFile.emit(null)"
    >clear</mat-icon>
  </div>
</div>
